/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AttendanceReportRequest,
  AttendanceReportResponse,
  HTTPValidationError,
} from '../models/index';
import {
    AttendanceReportRequestFromJSON,
    AttendanceReportRequestToJSON,
    AttendanceReportResponseFromJSON,
    AttendanceReportResponseToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
} from '../models/index';

export interface GenerateAttendanceReportRequest {
    attendanceReportRequest: AttendanceReportRequest;
    xOrganizationID?: string | null;
}

/**
 * 
 */
export class AttendanceReportsApi extends runtime.BaseAPI {

    /**
     * Generate attendance report for workshops of the organization in the header.  Staff of the organization only (401 without a user, 403 for non-staff). Administrators and the owner see every workshop of the organization; other staff see only the workshops they mentor, enforced here whatever `mentor_ids` or `workshop_ids` they send.  The filters combine with AND:  - **workshop_ids**: Optional workshop IDs; an id that is unknown, inactive or outside   the caller\'s scope is dropped silently - **class_ids**: Optional class IDs - **mentor_ids**: Optional mentor user IDs (replaced by the caller for non-admin staff) - **start_date**: Optional; workshops starting at or after it - **end_date**: Optional; workshops starting at or before it (a workshop that starts in   the period and ends after it is included)  Returns: - Per workshop: attendance (registered, checked in, absent, excused), problem-solving   statistics and metadata (name, mentor, class, times) - `totals`: summed counts, plus `students` and `students_checked_in` counted once each   across the workshops - An empty list (200) when nothing matches
     * Generate Attendance Report
     */
    async generateAttendanceReportRaw(requestParameters: GenerateAttendanceReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AttendanceReportResponse>> {
        if (requestParameters['attendanceReportRequest'] == null) {
            throw new runtime.RequiredError(
                'attendanceReportRequest',
                'Required parameter "attendanceReportRequest" was null or undefined when calling generateAttendanceReport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/attendance-reports/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AttendanceReportRequestToJSON(requestParameters['attendanceReportRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AttendanceReportResponseFromJSON(jsonValue));
    }

    /**
     * Generate attendance report for workshops of the organization in the header.  Staff of the organization only (401 without a user, 403 for non-staff). Administrators and the owner see every workshop of the organization; other staff see only the workshops they mentor, enforced here whatever `mentor_ids` or `workshop_ids` they send.  The filters combine with AND:  - **workshop_ids**: Optional workshop IDs; an id that is unknown, inactive or outside   the caller\'s scope is dropped silently - **class_ids**: Optional class IDs - **mentor_ids**: Optional mentor user IDs (replaced by the caller for non-admin staff) - **start_date**: Optional; workshops starting at or after it - **end_date**: Optional; workshops starting at or before it (a workshop that starts in   the period and ends after it is included)  Returns: - Per workshop: attendance (registered, checked in, absent, excused), problem-solving   statistics and metadata (name, mentor, class, times) - `totals`: summed counts, plus `students` and `students_checked_in` counted once each   across the workshops - An empty list (200) when nothing matches
     * Generate Attendance Report
     */
    async generateAttendanceReport(requestParameters: GenerateAttendanceReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AttendanceReportResponse> {
        const response = await this.generateAttendanceReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
